/**
 * @file This file contains very simple short utils to help.
 *
 * WARNING: This file was @generated by "ts/internal/autotest-step-generator/src/writers/utils.ts", do not edit.
 */
/** All wrapper steps. */
export const allWrapperTypes = new Set([
    'test-hide',
    'run-in',
    'run-if',
    'allow-internet',
    'connect-rubric',
    'weight',
    'test-timeout-each',
    'jupyter-notebook',
    'snapshot',
    'io-test',
    'code-structure-test',
    'quiz',
    'coding-question',
    'prompt-engineering-question',
]);
/** All non-wrapper steps. */
export const allNonWrapperTypes = new Set([
    'checkstyle',
    'java-compile',
    'junit5',
    'custom-test',
    'flake8',
    'pytest',
    'simple-python-test',
    'run-in-notebook',
    'output',
    'test-upload-files',
    'simple-match',
    'regex-match',
    'substring-match',
    'negative-match',
    'positive-match',
    'mcq',
    'select-all-question',
    'program',
    'install-dotnet',
    'install-java',
    'install-python',
    'install-node',
    'upload-files',
    'install-clang',
    'install-gcc',
    'install-r',
    'script',
    'auto-install-flake8',
    'auto-install-pytest',
    'auto-install-code-structure-test',
    'auto-install-simple-python-test',
    'auto-install-jupyter-notebook',
]);
/** All steps with a name. */
export const allWithNameTypes = new Set([
    'checkstyle',
    'java-compile',
    'junit5',
    'custom-test',
    'flake8',
    'pytest',
    'simple-python-test',
    'jupyter-notebook',
    'run-in-notebook',
    'output',
    'test-upload-files',
    'io-test',
    'simple-match',
    'regex-match',
    'substring-match',
    'code-structure-test',
    'negative-match',
    'positive-match',
    'coding-question',
    'prompt-engineering-question',
    'mcq',
    'select-all-question',
    'program',
    'upload-files',
    'script',
]);
/** All quiz question steps. */
export const allQuizTypes = new Set([
    'coding-question',
    'prompt-engineering-question',
    'mcq',
    'select-all-question',
]);
/** All test steps. */
export const ALL_TEST_STEP_TYPES = Object.freeze([
    'test-hide',
    'run-in',
    'run-if',
    'allow-internet',
    'connect-rubric',
    'weight',
    'checkstyle',
    'java-compile',
    'junit5',
    'custom-test',
    'test-timeout-each',
    'flake8',
    'pytest',
    'simple-python-test',
    'jupyter-notebook',
    'run-in-notebook',
    'output',
    'test-upload-files',
    'snapshot',
    'io-test',
    'simple-match',
    'regex-match',
    'substring-match',
    'code-structure-test',
    'negative-match',
    'positive-match',
    'quiz',
    'coding-question',
    'prompt-engineering-question',
    'mcq',
    'select-all-question',
    'program',
]);
/** All build/setup steps. */
export const ALL_BUILD_STEP_TYPES = Object.freeze([
    'install-dotnet',
    'install-java',
    'install-python',
    'install-node',
    'upload-files',
    'install-clang',
    'install-gcc',
    'install-r',
    'script',
]);
/** All build/setup steps that can be created by users. */
export const ALL_AUTO_INSTALL_STEP_TYPES = Object.freeze([
    'auto-install-flake8',
    'auto-install-pytest',
    'auto-install-code-structure-test',
    'auto-install-simple-python-test',
    'auto-install-jupyter-notebook',
]);
/** A mapping between step type and the display name. */
export const ALL_STEP_NAMES = Object.freeze({
    'test-hide': 'Hide',
    'run-in': 'Run Only In',
    'run-if': 'Run If',
    'allow-internet': 'Allow Internet',
    'connect-rubric': 'Connect Rubric',
    weight: 'Weight',
    checkstyle: 'Checkstyle',
    'java-compile': 'Java Compile',
    junit5: 'Junit5',
    'custom-test': 'Custom Test',
    'test-timeout-each': 'Timeout Each',
    flake8: 'Flake8',
    pytest: 'Pytest',
    'simple-python-test': 'Simple Python Test',
    'jupyter-notebook': 'Jupyter Notebook',
    'run-in-notebook': 'Run In Notebook',
    output: 'Output',
    'test-upload-files': 'Upload Files',
    snapshot: 'Isolate',
    'io-test': 'IO Test',
    'simple-match': 'Full Match',
    'regex-match': 'Regex Match',
    'substring-match': 'Substring Match',
    'code-structure-test': 'Code Structure Test',
    'negative-match': 'Negative Match',
    'positive-match': 'Positive Match',
    quiz: 'Quiz',
    'coding-question': 'Coding Question',
    'prompt-engineering-question': 'Prompt Engineering Question',
    mcq: 'Multiple Choice Question',
    'select-all-question': 'Select All Question',
    program: 'Script',
    'install-dotnet': 'Install .NET',
    'install-java': 'Install Java',
    'install-python': 'Install Python',
    'install-node': 'Install Node',
    'upload-files': 'Upload Files',
    'install-clang': 'Install Clang',
    'install-gcc': 'Install GCC',
    'install-r': 'Install R',
    script: 'Script',
    'auto-install-flake8': 'Auto Install Flake8',
    'auto-install-pytest': 'Auto Install Pytest',
    'auto-install-code-structure-test': 'Auto Install Code Structure Test',
    'auto-install-simple-python-test': 'Auto Install Simple Python Test',
    'auto-install-jupyter-notebook': 'Auto Install Jupyter Notebook',
});
/**
 * Grouping data of the build steps.
 *
 * In the ATv2 editor UI, the steps are grouped into different groups for discovery.
 * This object describes what groups there are for build steps, and what steps are in each group.
 *
 * Each group contains the 'stepTags' field, which enumerates the tag of the children steps.
 * Each group contains the 'name' field, which records the name of the group.
 * This should be used in the user interface to render the name of the group.
 */
export const BUILD_STEP_GROUP_DATA = Object.freeze([
    Object.freeze({ name: 'Scripting', stepTags: ['script'] }),
    Object.freeze({ name: 'Artifacts', stepTags: ['upload-files'] }),
    Object.freeze({
        name: 'Installations',
        stepTags: [
            'install-clang',
            'install-dotnet',
            'install-gcc',
            'install-python',
            'install-java',
            'install-node',
            'install-r',
        ],
    }),
]);
/**
 * Grouping data of the test steps.
 *
 * In the ATv2 editor UI, the steps are grouped into different groups for discovery.
 * This object describes what groups there are for test steps, and what steps are in each group.
 *
 * Each group contains the 'stepTags' field, which enumerates the tag of the children steps.
 * Each group contains the 'name' field, which records the name of the group.
 * This should be used in the user interface to render the name of the group.
 */
export const TEST_STEP_GROUP_DATA = Object.freeze([
    Object.freeze({ name: 'Scoring', stepTags: ['connect-rubric', 'weight'] }),
    Object.freeze({ name: 'Custom Code', stepTags: ['custom-test', 'program'] }),
    Object.freeze({ name: 'Visibility', stepTags: ['test-hide'] }),
    Object.freeze({
        name: 'IO Test',
        stepTags: ['io-test', 'simple-match', 'regex-match', 'substring-match'],
    }),
    Object.freeze({
        name: 'Code Structure',
        stepTags: ['code-structure-test', 'positive-match', 'negative-match'],
    }),
    Object.freeze({
        name: 'Quiz',
        stepTags: [
            'quiz',
            'mcq',
            'select-all-question',
            'coding-question',
            'prompt-engineering-question',
        ],
    }),
    Object.freeze({ name: 'Java', stepTags: ['java-compile', 'junit5', 'checkstyle'] }),
    Object.freeze({
        name: 'Python',
        stepTags: ['pytest', 'simple-python-test', 'flake8'],
    }),
    Object.freeze({
        name: 'Jupyter Notebook',
        stepTags: ['jupyter-notebook', 'run-in-notebook'],
    }),
    Object.freeze({ name: 'Artifacts', stepTags: ['output', 'test-upload-files'] }),
    Object.freeze({ name: 'Conditions', stepTags: ['run-if', 'run-in'] }),
    Object.freeze({
        name: 'Utilities',
        stepTags: ['test-timeout-each', 'allow-internet', 'snapshot'],
    }),
]);
